
/**
 * Internal dependencies
 */
import {
    ADDONS_RECEIVE,
    ADDONS_REQUEST,
    ADDONS_REQUEST_SUCCESS,
    ADDONS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllAddons, requestingAddons } from './selectors';

/**
 * [description]
 * 
 * @param  {Function} includeSupport [description]
 * @return {[type]}                  [description]
 */
export const requestAddons = (page = 1, limit = 10) => (dispatch) => {
    dispatch({
        type: ADDONS_REQUEST
    });
    return cscom.addon().list()
        .then(addons => {
            dispatch({
                type: ADDONS_REQUEST_SUCCESS,
            });
            dispatch({
                type: ADDONS_RECEIVE,
                payload: {
                    items: addons
                }
            });
            return addons
        }).catch((error) => {
            dispatch({
                type: ADDONS_REQUEST_FAILURE,
                error,
            });
        });
}



/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestAddonsIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const addons = getAllAddons(getState());
	const requesting = requestingAddons(getState());

	if (addons.length == 0 && requesting == false) {
		return dispatch(requestAddons(...props))
	}

	return addons;
}